export const datadog = {
  version: '20260729.2',
  service: 'auth-frontend-service',
  site: 'us3.datadoghq.com',
  clientToken: 'pub7b861ad85e9b2d2b0d9976097e9af604',
  applicationId: '61f62ae1-559c-4392-bb45-e069683f973a',
};
